import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const RequestCallPhone: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      {...props}
      ref={ref}
    >
      <path
        d="M0.603731 9.30357C0.215854 8.25357 -0.0579411 7.18075 0.0105077 6.03945C0.0561403 5.33184 0.329936 4.73836 0.85471 4.23619C1.4023 3.71119 1.94989 3.14054 2.49748 2.61555C3.20479 1.90794 4.11744 1.90794 4.82474 2.61555C5.25825 3.04924 5.71458 3.50576 6.14808 3.93945C6.58159 4.37315 7.0151 4.78402 7.4258 5.21771C8.17873 5.97097 8.17873 6.86118 7.4258 7.61444C6.90102 8.16226 6.35343 8.68726 5.80584 9.21226C5.66894 9.34922 5.64613 9.46335 5.71457 9.64596C6.07964 10.5133 6.58159 11.2666 7.17482 11.997C8.33845 13.4351 9.68461 14.7133 11.2589 15.7177C11.6012 15.9231 11.9662 16.0829 12.3313 16.2655C12.5138 16.3568 12.6279 16.334 12.7876 16.1742C13.3124 15.6264 13.86 15.0785 14.4076 14.5307C15.1149 13.8231 16.0275 13.8231 16.7348 14.5307C17.6019 15.3981 18.4917 16.2655 19.3587 17.1557C20.0888 17.8861 20.0888 18.7992 19.3587 19.5296C18.8567 20.0318 18.332 20.5111 17.8756 21.0361C17.1912 21.7894 16.347 22.0405 15.3659 21.9948C13.9513 21.9263 12.6279 21.447 11.373 20.8307C8.56661 19.4611 6.14808 17.5666 4.14025 15.1698C2.63438 13.4122 1.4023 11.472 0.603731 9.30357ZM21.9948 9.78475C21.474 4.64275 17.3958 0.54874 12.2624 0.00603234C11.6426 -0.0594856 11.0992 0.4168 11.0992 1.04024V1.06018C11.0992 1.59421 11.5039 2.03798 12.0348 2.09394C16.1719 2.53001 19.4834 5.82458 19.9247 9.97754C19.9816 10.5129 20.4314 10.9192 20.9695 10.9133C21.5741 10.9066 22.0557 10.3866 21.9948 9.78475ZM11.0992 4.9807V4.99528C11.0992 5.49298 11.4477 5.93532 11.938 6.01934C12.9457 6.19201 13.8779 6.67368 14.6129 7.40901C15.3479 8.14433 15.8294 9.07693 16.002 10.085C16.086 10.5756 16.5281 10.9242 17.0256 10.9242H17.0348C17.6765 10.9242 18.1747 10.3469 18.0625 9.71484C17.5416 6.78001 15.223 4.4598 12.3039 3.95184C11.6734 3.84212 11.0992 4.34043 11.0992 4.9807Z"
        fill="url(#paint0_linear_14849_10418)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14849_10418"
          x1="24.1948"
          y1="3.14352"
          x2="1.25097"
          y2="18.2235"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47F59E" />
          <stop offset="1" stopColor="#04AFAD" />
        </linearGradient>
      </defs>
    </svg>
  )
})

RequestCallPhone.displayName = 'RequestCallPhone'
